<div class="shortcont f-reg f-black roboto-r ">
        <div class="basicrow m-bott-ii">
            <div class="basicrow f-black f-mildt roboto-m">
                Actualiza las Preguntas de Seguridad
            </div>

            <div class="basicrow m-top-ii text-justify">
                Por favor selecciona dos preguntas de seguridad. Esto nos ayudar&aacute; a verificar tu identidad en caso de que olvides tu contrase&ntilde;a.
            </div>

            <div class="basicrow m-top">
                <label class="label-f">
                    &#42; Primera Pregunta de Seguridad
                </label>

                <select [(ngModel)]="this.questionID1" class="sel-f">
                    <option *ngIf="this.questionsData!=undefined && this.questionsData!=null" disabled selected>Seleccione una Pregunta</option>
                    <option *ngFor="let account of this.questionsData" [ngValue]="account.questionID">{{account.question}}</option>
                </select>

            </div>

            <div class="basicrow m-top-i">
                <label class="label-f">
                    &#42; Respuesta Secreta
                </label>

                <input class="inp-f" [(ngModel)]="this.pregunta1">
            </div>

            <div class="basicrow m-top-i">
                <label class="label-f">
                    &#42; Segunda Pregunta de Seguridad
                </label>
                <select [(ngModel)]="this.questionID2" class="sel-f">
                    <option *ngIf="this.questionsData!=undefined && this.questionsData!=null"  disabled selected>Seleccione una Pregunta</option>
                    <option *ngFor="let account of this.questionsData" [ngValue]="account.questionID">{{account.question}}</option>
                </select>
            </div>

            <div class="basicrow m-top-i">
                <label class="label-f">
                    &#42; Respuesta Secreta
                </label>

                <input class="inp-f" [(ngModel)]="this.pregunta2">
            </div>
        </div>

        <div class="basicrow m-top">
            <div class="logline full"></div>
        </div>

        <div class="basicrow text-center m-top">
            <a  class="btns def-i red pull-right vcenter" (click)="this.aceptarPreguntas();">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>